"use client"
import { Box, Container, Typography, Link, useTheme } from "@mui/material"
import { Link as RouterLink } from "react-router-dom"
import config from "../config"

const Footer = () => {
  const theme = useTheme()
  const currentYear = new Date().getFullYear()

  return (
    <Box
      component="footer"
      sx={{
        py: 2,
        borderTop: "1px solid rgba(255, 255, 255, 0.1)",
        background: "rgba(0, 0, 0, 0.5)",
        width: "100%",
        flexShrink: 0,
        position: "relative",
        zIndex: 1,
      }}
    >
      <Container maxWidth="xl">
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", sm: "row" },
            justifyContent: "space-between",
            alignItems: { xs: "center", sm: "flex-start" },
            gap: { xs: 2, sm: 0 },
          }}
        >
          <Typography variant="body2" color="text.secondary">
            {currentYear} DarkEdge
          </Typography>

          <Box
            sx={{
              display: "flex",
              gap: { xs: 2, sm: 3 },
              flexWrap: "wrap",
              justifyContent: "center",
            }}
          >
            <Link
              component={RouterLink}
              to="/privacy"
              sx={{
                color: "text.secondary",
                textDecoration: "none",
                "&:hover": {
                  color: theme.palette.primary.main,
                  textDecoration: "none",
                },
              }}
            >
              <Typography variant="body2">Privacy Policy</Typography>
            </Link>
            <Link
              component={RouterLink}
              to="/terms"
              sx={{
                color: "text.secondary",
                textDecoration: "none",
                "&:hover": {
                  color: theme.palette.primary.main,
                  textDecoration: "none",
                },
              }}
            >
              <Typography variant="body2">Terms of Service</Typography>
            </Link>
            <Link
              component={RouterLink}
              to="/pricing"
              sx={{
                color: "text.secondary",
                textDecoration: "none",
                "&:hover": {
                  color: theme.palette.primary.main,
                  textDecoration: "none",
                },
              }}
            >
              <Typography variant="body2">Pricing</Typography>
            </Link>
            <Link
              component={RouterLink}
              to="/contact"
              sx={{
                color: "text.secondary",
                textDecoration: "none",
                "&:hover": {
                  color: theme.palette.primary.main,
                  textDecoration: "none",
                },
              }}
            >
              <Typography variant="body2">Contact</Typography>
            </Link>
            <Link
              href={config.EPVP_URL}
              target="_blank"
              rel="noopener noreferrer"
              title="Our elitepvpers release thread"
              aria-label="Our elitepvpers release thread"
              sx={{
                display: "inline-flex",
                alignItems: "center",
                opacity: 0.6,
                transition: "opacity 0.3s ease",
                "&:hover": { opacity: 1 },
              }}
            >
              <Box component="img" src={config.EPVP_FAVICON_URL} alt="elitepvpers" sx={{ width: 16, height: 16, display: "block" }} />
            </Link>
          </Box>
        </Box>
      </Container>
    </Box>
  )
}

export default Footer
